import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ExportStatusLabel from './components/ExportStatusLabel/ExportStatusLabel.component'
import ExportModal from './components/ExportModal/ExportModal.component'
import ReportingConfig from './components/ReportingConfig/ReportingConfig.container'
import ExportApiConfig from './components/ExportApiConfig/ExportApiConfig.container'
import DeleteExportItemModal from './components/DeleteExportItemModal/DeleteExportItemModal.component'
import ResetAllExportItemsModal from './components/ResetAllExportItemsModal/ResetAllExportItemsModal.component'
import Spinner from 'shared/components/common/Spinner/Spinner.component'
import Button from 'shared/components/common/Button/Button.component'
import { createDivAtom } from 'shared/atoms/factory'
import Modal from 'shared/components/common/Modal/Modal.component'
import styles from 'analytics/components/Sections/basic.module.scss'
import exportStyles from './Export.module.scss'

const ExportMainWrapper = createDivAtom(),
      ExportsListSection = createDivAtom(),
      ExportsListWrapper = createDivAtom(),
      ExportsListItem = createDivAtom(),
      ListItemTitle = createDivAtom(),
      ExportsListTitle = createDivAtom(),
      ExportSection = createDivAtom(),
      ExportDescription = createDivAtom(),
      EmptyInfoTitle = createDivAtom(),
      ButtonWrapper = createDivAtom(),
      Title = createDivAtom(),
      Subtitle = createDivAtom()

const Export = ({
  isRequesting,
  isLoadingExports,
  onExportV2,
  onLoadExports,
  agentId,
  exports,
  saveConfig,
  exportFailed,
  exportSuccess,
  onCloseExportErrorModal
}) => {
  useEffect(() => {
    if(agentId && agentId !== 'default') {
      onLoadExports()
    }
  }, [ agentId ])

  const [ isOpenExportModal, changeIsOpenExportModal ] = useState(false)
  const toggleExportModal = () => {
    changeIsOpenExportModal(!isOpenExportModal)
  }

  return (
    <main className={styles.main}>

      <header className={classNames(exportStyles.header, styles.headerWithTitle)}>

        <div className={classNames(exportStyles.headerBody)}>
          <span className={exportStyles.headerTitle}>
            Reporting configuration
          </span>

          <ButtonWrapper className={exportStyles.buttonWrapper}>
            <Button className={exportStyles.buttonBody}
              primary
              onClick={saveConfig}
              title='Save'
            />
          </ButtonWrapper>
        </div>

      </header>
      
      <ExportModal
        isOpen={isOpenExportModal}
        onToggle={toggleExportModal}
        onExportV2={onExportV2}
      />

      <Modal
        isOpen={exportFailed || exportSuccess}
        onClose={onCloseExportErrorModal}
        size='medium'
      >
        { exportSuccess ? <Title className={styles.successModalTitle}>Started exporting data</Title>
          : <Title className={styles.errorModalTitle}>ERROR!</Title>
        }

        <Subtitle className={styles.subtitle}>
          {!!exportSuccess && 'You will get an email when the data is ready to download'}
          {!!exportFailed && 'Failed to download. Please try again or contact support'}
        </Subtitle>

        <ButtonWrapper className={exportStyles.buttonWrapper}>
          <Button
            onClick={onCloseExportErrorModal}
            title='OK'
          />
        </ButtonWrapper>

      </Modal>

      <div className={exportStyles.menu}>
        <ReportingConfig />
        <ExportApiConfig />
        <ExportMainWrapper className={exportStyles.exportMainWrapper}>
          <Spinner visible={isRequesting || isLoadingExports}/>

          <ExportsListSection>
            <ExportsListTitle
              className={exportStyles.exportsListTitle}
            >
              <Title>Manual exports</Title>

              <ResetAllExportItemsModal
                disabled={isRequesting || isLoadingExports}
              />
            </ExportsListTitle>

            {Boolean(exports?.length > 0) && (
              <ExportsListWrapper
                className={exportStyles.exportsListWrapper}
              >
                {
                  exports.map((item, index) => (
                    <ExportsListItem
                      key={index}
                      className={exportStyles.exportsListItem}
                    >
                      <ListItemTitle>
                        {item.title}
                      </ListItemTitle>

                      <ExportStatusLabel
                        status={item.status}
                      />

                      <ButtonWrapper className={exportStyles.exportItemButtonWrapper}>
                        <DeleteExportItemModal exportId={item.exportId} />

                        <Button
                          className={exportStyles.buttonBody}
                          onClick={() => {
                            if(!item.url) return

                            window.open(item.url, '_blank')
                          }}
                          title='download'
                          disabled={!item.url}
                        />
                      </ButtonWrapper>
                    </ExportsListItem>
                  ))
                }
              </ExportsListWrapper>
            )}


            {Boolean(!isLoadingExports && exports?.length === 0) && (
              <EmptyInfoTitle
                className={exportStyles.emptyInfoTitle}
              >
                No exports yet.
              </EmptyInfoTitle>
            )}
          </ExportsListSection>

          <ExportSection
            className={exportStyles.exportSection}
          >
            <ExportDescription>

            </ExportDescription>

            <Button
              className={exportStyles.buttonBody}
              primary
              onClick={toggleExportModal}
              title='export'
            />
          </ExportSection>

        </ExportMainWrapper>
      </div>
    </main>
  )
}

Export.propTypes = {
  isRequesting: PropTypes.bool.isRequired,
  isLoadingExports: PropTypes.bool.isRequired,
  agentId: PropTypes.string.isRequired,
  exports: PropTypes.array.isRequired,
  onExportV2: PropTypes.func.isRequired,
  onLoadExports: PropTypes.func.isRequired,
  saveConfig: PropTypes.func.isRequired,
  exportFailed: PropTypes.bool.isRequired,
  exportSuccess: PropTypes.bool.isRequired,
  onCloseExportErrorModal: PropTypes.func.isRequired
}

export default Export
